export const pcPageConfig = {
  "title": "Sales Breakdown",
  "titleCN": "销售构成",
  "path": "/monetization/salesBreakdown",
  "defaultTab": "revenue",
  "tabList": [
    {
      "id": "revenue",
      "tabName": "Sales Breakdown",
      "tabNameCN": "销售构成",
      "isHaveNotification": true,
      "refresh": false,
      "notificationPath": "/monetization/salesBreakdown",
      "path": "/monetization/salesBreakdown",
      "tabIcon": "",
      "logConfig": {
        "pageId": "204201",
        "pageName": "salesBreakdown",
        "extInfo": "salesBreakdown",
        "pagePath": "/monetization/salesBreakdown"
      },
      "filters": [
        {
          "name": "SalesBreakdownFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/monetization/salesBreakdown",
          "componentList": [
            {
              "name": "SegmentTabsCo",
              "data": {
                "metric": "gross_revenue"
              },
              "props": {
                "config": {
                  "dataKey": "metric",
                  "tabList": {
                    "Day": [
                      {
                        "name": "Gross Revenue($)",
                        "nameCn": "总收入($)",
                        "resName": "gross_revenue",
                        "formatRule": "thousands2Decimal"
                      },
                      {
                        "name": "Revenue After Refund & Tax($)",
                        "nameCn": "净收入($)",
                        "resName": "net_revenue",
                        "formatRule": "thousands2Decimal"
                      },
                      {
                        "name": "Revenue After Refund($)",
                        "nameCn": "收入(剔除退款)($)",
                        "resName": "revenue_after_chargeback",
                        "formatRule": "thousands2Decimal"
                      },
                      {
                        "name": "Base Game Revenue After Refund & Tax($)",
                        "nameCn": "本体拷贝净收入($)",
                        "resName": "units_revenue",
                        "formatRule": "thousands2Decimal"
                      },
                      {
                        "name": "Gross Base Game Units",
                        "nameCn": "本体销量",
                        "resName": "gross_full_game_units",
                        "formatRule": "thousandsInit"
                      },
                      {
                        "name": "Base Game Units After Refund",
                        "nameCn": "本体拷贝净销量",
                        "resName": "units_number",
                        "formatRule": "thousandsInit"
                      },
                      {
                        "name": "Refund Revenue($)",
                        "nameCn": "退款收入($)",
                        "resName": "refund_revenue",
                        "formatRule": "thousands2Decimal"
                      },
                      {
                        "name": "Lifetime Refund Rate",
                        "nameCn": "累计退款率",
                        "resName": "accumulated_refund_rate",
                        "formatRule": "percent2Decimal",
                        "hideBarPercent": true,
                        "isNotAccumated": true,
                        "moleculeKey": "accumulated_chargeback_units",
                        "denominatorKey": "accumulated_gross_units"
                      }
                    ]
                  },
                  "isShowCollapseButton": false
                }
              },
              "children": [
                {
                  "name": "SalesBreakdownTreeChart"
                }
              ]
            },
            {
              "name": "OverallTableCo",
              "className": "margin-t-20",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "lockColumns": [
                    {
                      "key": "date",
                      "lockRainbowKey": "Pc Lock Date Tip",
                      "unlockRainbowKey": "Pc Unlock Date Tip",
                      "showDimList": [
                        "date"
                      ]
                    }
                  ],
                  "isUseNewSortParams": true,
                  "isHavePageDefaultSelector": true,
                  "isHaveDiff": false,
                  "pageSizeOptions": [
                    10,
                    20,
                    30,
                    40,
                    50
                  ],
                  "showStatistic": [
                    "sum",
                    "avg_no_null"
                  ],
                  "valueTypeConfig": {
                    "valueType": "value_only",
                    "isShowChange": false,
                    "isShowSdlw": true
                  },
                  "dimensionConfig": {
                    "dateDisabled": false,
                    "defaultAccumulation": [
                      "date",
                      "category",
                      "product"
                    ],
                    "isShowCountryFlag": true
                  },
                  "api": {
                    "tableApi": "/api/v1/dashboard/pc/monetization/sales/breakdown/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/pc/monetization/sales/breakdown/overall_performance/download"
                  },
                  "titleEn": "Overall Payment",
                  "titleCn": "总体付费表现",
                  "componentMetrics": [
                    {
                      "metricKey": "gross_revenue",
                      "reqMetricKey": "gross_revenue",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 160,
                      "cnWidth": 160,
                      "enName": "Gross Revenue($)",
                      "cnName": "总收入($)",
                      "rainbowKey": "Pc Gross Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "net_revenue",
                      "reqMetricKey": "net_revenue",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 200,
                      "enWidth": 270,
                      "cnWidth": 180,
                      "enName": "Revenue After Refund & Tax($)",
                      "cnName": "净收入($)",
                      "rainbowKey": "Net Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "revenue_after_chargeback",
                      "reqMetricKey": "revenue_after_chargeback",
                      "enPercentWidth": 270,
                      "cnPercentWidth": 190,
                      "enWidth": 270,
                      "cnWidth": 200,
                      "enName": "Revenue After Refund($)",
                      "cnName": "收入(剔除退款)($)",
                      "rainbowKey": "Pc Revenue After Refund($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "net_units_sold",
                      "reqMetricKey": "net_units_sold",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 200,
                      "enWidth": 180,
                      "cnWidth": 150,
                      "enName": "Units After Refund",
                      "cnName": "产品净销量",
                      "rainbowKey": "Net Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "gross_units_sold",
                      "reqMetricKey": "gross_units_sold",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 140,
                      "cnWidth": 160,
                      "enName": "Gross Units",
                      "cnName": "总销量",
                      "rainbowKey": "Pc Gross Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "refunded_units",
                      "reqMetricKey": "refunded_units",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 150,
                      "cnWidth": 130,
                      "enName": "Refunded Units",
                      "cnName": "退款数",
                      "rainbowKey": "Pc Refunded Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_net_revenue",
                      "reqMetricKey": "units_net_revenue",
                      "enPercentWidth": 360,
                      "cnPercentWidth": 200,
                      "enWidth": 360,
                      "cnWidth": 160,
                      "enName": "Base Game Revenue After Refund & Tax($)",
                      "cnName": "本体拷贝净收入($)",
                      "rainbowKey": "Net Units Rev",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "units_number",
                      "reqMetricKey": "units_number",
                      "enPercentWidth": 260,
                      "cnPercentWidth": 160,
                      "enWidth": 260,
                      "cnWidth": 160,
                      "enName": "Base Game Units After Refund",
                      "cnName": "本体拷贝净销量",
                      "rainbowKey": "Pc Sales Overview Metrics Net Full Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "accumulated_full_game_units",
                      "reqMetricKey": "accumulated_full_game_units",
                      "enPercentWidth": 330,
                      "cnPercentWidth": 200,
                      "enWidth": 330,
                      "cnWidth": 150,
                      "enName": "Lifetime Base Game Units After Refund",
                      "cnName": "累计本体净销量",
                      "rainbowKey": "Pc Lifetime Net Full Game Units",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "refund_revenue",
                      "reqMetricKey": "refund_revenue",
                      "enPercentWidth": 210,
                      "cnPercentWidth": 160,
                      "enWidth": 170,
                      "cnWidth": 170,
                      "enName": "Refund Revenue($)",
                      "cnName": "退款收入($)",
                      "rainbowKey": "Pc Refund Revenue",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "accumulated_refund_rate",
                      "reqMetricKey": "accumulated_refund_rate",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 160,
                      "enWidth": 230,
                      "cnWidth": 130,
                      "enName": "Lifetime Refund Rate",
                      "cnName": "累计退款率",
                      "rainbowKey": "Pc Accumulated Refund Rate",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "asp",
                      "reqMetricKey": "asp",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 160,
                      "enWidth": 210,
                      "cnWidth": 130,
                      "enName": "Average Selling Price",
                      "cnName": "平均销售价格",
                      "rainbowKey": "Pc Average Selling Price (ASP)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ]
};